import { sendGtmEvent } from "~/analytics/definitions";
import { VariationIds } from "~/common/globals";
import updateVariationIds from "~/Gtm/updateVariationIds";

interface SendSearchABVariationGtmEventProps {
  appliedSearchStrategies?: string[];
  abTest: string;
}

const sendSearchABVariationGtmEvent = ({
  appliedSearchStrategies,
  abTest,
}: SendSearchABVariationGtmEventProps) => {
  let modelName = "catalog_original_model";
  let variationIdOption = "A";

  if (abTest === "soon") {
    modelName = "catalog_relevancy_model";
    variationIdOption = "B";
  }

  /*
   * Both the base and test variations can have "WordRemoval" applied,
   * only the test variation can have "WordRemovalByRelevancy" applied.
   * In some cases, neither will be applied, based on the search query.
   */
  const isWordRemovalApplied =
    appliedSearchStrategies?.some(
      (s) => s === "WordRemoval" || s === "WordRemovalByRelevancy",
    ) ?? false;

  updateVariationIds([
    {
      featureName: VariationIds.WordRemovalSearchModel_AB_Test,
      featureOption: variationIdOption,
    },
  ]);

  sendGtmEvent({
    event: "Search_AB_Test",
    eventLabel: `${isWordRemovalApplied ? 1 : 0}_${modelName}`,
    eventAction: "Search Impression",
  });
};

export default sendSearchABVariationGtmEvent;
